import React from 'react';
import CurrencyInput from 'react-currency-input-field';
import RenderError from '../../components/RenderError';

function CurrentPracticesWeedControlMethodQuestion({
  weedControlMethodOptions,
  formData,
  setFormData,
  handleCheckMethod,
  handleMethodInputChange,
  errors
}) {
  return (
    <div className="form__field form__field--required">
      <label className="form__label">
        What weed control methods did you use before purchasing your
        propane-fueled flame weed control system? Check all that apply.
      </label>
      <p>
        For each weed control method listed below, please include the total
        percentage of these crops that you used this weed control method on; and
        how much you spent on these weed control methods per acre (factoring in
        costs of equipment, chemicals and materials, energy, and labor) in a
        typical year.
      </p>
      {errors.weedControlMethods && (
        <RenderError error={errors.weedControlMethods.weedControlMethods} />
      )}
      {Object.values(weedControlMethodOptions).map((method) => (
        <div key={method}>
          <label
            className="form__checkbox u--display-flex u--justify-content-flex-end"
            style={{ gap: '2rem' }}
          >
            <input
              type="checkbox"
              value={method}
              checked={method in formData.weedControlMethods}
              onChange={handleCheckMethod}
            />
            <span style={{ flexGrow: 1 }}>{method}</span>
            <div
              className={`u--display-${
                method in formData.weedControlMethods ? 'flex' : 'none'
              } u--flex-direction-column`}
            >
              <small>% of Crops Treated</small>
              <input
                type="number"
                value={
                  formData.weedControlMethods[method] &&
                  formData.weedControlMethods[method].percentCropsTreated
                    ? formData.weedControlMethods[method].percentCropsTreated
                    : ''
                }
                name="percentCropsTreated"
                onChange={(event) => handleMethodInputChange(event, method)}
              />
              {errors.weedControlMethods &&
                errors.weedControlMethods.hasOwnProperty(method) && (
                  <RenderError
                    error={
                      errors.weedControlMethods[method].percentCropsTreated
                    }
                  />
                )}
            </div>
            <div
              className={`u--display-${
                method in formData.weedControlMethods ? 'flex' : 'none'
              } u--flex-direction-column`}
            >
              <small>Cost ($ per acre)</small>
              <CurrencyInput
                name="weedControlCost"
                prefix="$"
                value={
                  formData.weedControlMethods[method] &&
                  (formData.weedControlMethods[method].weedControlCost !==
                    null) &
                    (formData.weedControlMethods[method].weedControlCost !==
                      undefined)
                    ? parseInt(
                        formData.weedControlMethods[method].weedControlCost
                      )
                    : 0
                }
                onValueChange={(value, name) => {
                  setFormData({
                    ...formData,
                    weedControlMethods: {
                      ...formData.weedControlMethods,
                      [method]: {
                        ...formData.weedControlMethods[method],
                        [name]: value
                      }
                    }
                  });
                }}
              />
              {errors.weedControlMethods &&
                errors.weedControlMethods.hasOwnProperty(method) && (
                  <RenderError
                    error={errors.weedControlMethods[method].weedControlCost}
                  />
                )}
            </div>
          </label>
          {method in formData.weedControlMethods &&
            (method === 'Other (please specify)' ? (
              <div className="u--margin-top-10 u--margin-left-10">
                <input
                  type="text"
                  name="Other (please specify)"
                  value={formData.weedControlMethods[method].method}
                  onChange={(event) => {
                    setFormData({
                      ...formData,
                      weedControlMethods: {
                        ...formData.weedControlMethods,
                        [event.target.name]: {
                          ...formData.weedControlMethods[method],
                          method: event.target.value
                        }
                      }
                    });
                  }}
                  className="form__input form__input--lg u--width-100"
                />
                {errors[method] && (
                  <RenderError error={errors[weedControlMethods_other]} />
                )}
              </div>
            ) : (
              ''
            ))}
        </div>
      ))}
    </div>
  );
}

export default CurrentPracticesWeedControlMethodQuestion;
